import { makeStyles } from 'tss-react/mui';
import { Typography, Container } from '@mui/material';
import { LocalizationIds } from 'helpers/Localizations';
import { FormattedMessage } from 'react-intl';


let useStyles = makeStyles()(() => ({
    homepage: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#FFF',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
    },
    container: {
        marginTop: '16%'
    }
}));


let Error403 = () => {
    let { classes } = useStyles();

    return (
        <div className={classes.homepage}>
            <Container
                maxWidth="md"
                className={classes.container}
            >
                <Typography align="center" variant="h1">
                    <FormattedMessage id={LocalizationIds.SomethingWrong} />
                </Typography>
                <Typography align="center" variant="h2">
                    <FormattedMessage id={LocalizationIds.TryLoginLogout} />
                </Typography>
            </Container>
        </div>
    )
}

export default Error403;